<div #container class="container ml-8">
  <ng-container *ngFor="let el of (elements$ | async)">
    <yf-cost-card [$el]="el">
    </yf-cost-card>
  </ng-container>
</div>